// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ea-a";
export var fulfillmentFormRail = "_ea-9";
export var headerTitleRow = "_ea-c";
export var orderDetailsWrapper = "_ea-7";
export var orderLinkTrigger = "_ea-2";
export var paymentInformationGrid = "_ea-h";
export var paymentSummaryColumn = "_ea-i";
export var shipmentContainer = "_ea-b";
export var shipmentDetailsMainPane = "_ea-8";
export var shipmentNavigationCard = "_ea-5";
export var shipmentNavigationRail = "_ea-3";
export var shipmentNavigationRailHeader = "_ea-4";
export var shipmentSummaryFact = "_ea-e";
export var shipmentSummaryGrid = "_ea-d";
export var shipmentSummaryMetadataRow = "_ea-f";
export var shipmentSummaryTags = "_ea-g";
export var shipmentWorkspace = "_ea-0";
export var shipmentWorkspaceContent = "_ea-6";
export var shipmentWorkspaceHeader = "_ea-1";